export const COLUMNCOLORS = ['#49C4E5', '#8471F2', '#67E2AE', '#FF9898', '#828FA3', '#E4EBFA']

export const BTNWIDTH = '255px'

export const TASKMENU = ['Edit Task', 'Delete Task']
export const BOARDMENU = ['Edit Board', 'Delete Board']

export enum DrawerPaddingX {
   Xs = '24px'
}

export enum DrawerWidth {
   Sm = '260px',
   Md = '300px'
}

export enum AppbarHeight {
   Xs = '64px',
   Sm = '72px'
}

